module.exports = __webpack_public_path__ + "static/img/momPlatform.5aad3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/momPlatform.png
// module id = FmQn
// module chunks = 1